import { SchoolType } from "../domain/School";

export const cardsColName: {
  [key in SchoolType]: string;
} = {
  elementary: "Cards",
  juniorhigh: "CardsJ",
};
